import { lightboxFactory, LightboxImageElement, MewsImageProps, withMewsSrcSet } from '@optimus-web/core';
import { ImageList } from '../ImageList';

const ImageWithMewsSrc = withMewsSrcSet(LightboxImageElement);
const IMAGE_SIZES = '(min-width: 950px) 65vw, 100vw';

const LightboxImageWithSizes = (props: MewsImageProps) => (
    <ImageWithMewsSrc {...props} sizes={IMAGE_SIZES} widthSet={[320, 480, 768, 1366, 1920]} />
);

export const Lightbox = lightboxFactory({
    LightboxImage: LightboxImageWithSizes,
    ImageList,
});
